module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/sh-acd7b6efcbb9ea9ca7e6f87ca23d5b9b.svg";